<template>
  <frontPage/>
  <div class="token-container">
    <h2>Token: {{ tokenInfo.Token.name }} ({{ tokenInfo.Token.symbol }})</h2>
    <h2>Address: {{ tokenInfo.Token.address}} </h2>

    <div class="tabs">
      <button v-on:click="activeTab = 'about'" :class="{active: activeTab === 'about'}">About</button>
      <button v-on:click="activeTab = 'extensions'" :class="{active: activeTab === 'extensions'}">Extensions Info</button>
      <button v-on:click="activeTab = 'more-info'" :class="{active: activeTab === 'more-info'}">More Info</button>
    </div>

    <div class="tab-content">
      <div v-if="activeTab === 'about'" class="about">
        {{ tokenInfo.Token.name }} is a set of APIs, SDKs, and tools to build and scale web3 apps.
        <h3>Functions:</h3>
        <div>Swap </div>

      </div>

      <div v-if="activeTab === 'extensions'" class="extensions-info">
        <div> Chain ID: {{ tokenInfo.Token.chainID }}</div>  
        <div> l1GatewayAddress: {{ tokenInfo.Token.extensions.l1GatewayAddress }}</div> 
        <div> l2GatewayAddress: {{ tokenInfo.Token.extensions.l2GatewayAddress }}</div>
        <div>l1Address: {{ tokenInfo.Token.extensions.l1Address }}</div>  
      </div>

      <div v-if="activeTab === 'more-info'" class="more-info">
       
        <div> Docs: <link> https://docs.alchemy.com/  </div>
      </div>
    </div>
  </div>
</template>

<script>
import frontPage from './frontPage.vue';
export default {
  components: {
    frontPage
  },
  data() {
    return {
      tokenInfo: null,
      activeTab: 'about', // Default active tab
    };
  },
  created() {
    this.tokenInfo = JSON.parse(this.$route.query.submission);
  },
};
</script>

<style scoped>
.token-container {
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 2px 5px rgba(0,0,0,0.1);
}

.tabs {
  display: flex; /* Aligns the buttons in a row */
  margin-bottom: 10px;
}

.tabs button {
  padding: 10px 20px;
  border: none;
  background-color: #5b5b5b;
  margin-right: 5px;
  cursor: pointer;
  flex: 1; /* Optional: Makes each tab take equal width */
}

.tabs button.active {
  background-color: #272727;
}

.tab-content {
  margin-top: 20px;
}

/* Additional styling for your tabs and content can go here */
</style>
